import React, { useContext, useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import { Row, Col, Layout, Button, Avatar, Tabs } from 'antd';
import { LoginOutlined, ArrowLeftOutlined } from '@ant-design/icons';
// import { useSwipeable, Swipeable } from 'react-swipeable';
import { ThemeContext } from '../Context/ThemeContext';
import { ExploreContext } from '../Context/ExploreContext';
import ExploreUser from '../Card/ExploreUser';
import { ProfileContext } from '../Context/ProfileContext';

import * as Config from '../../Config';
import HelmetSeo from '../../Assets/Utilities/HelmetSeo';
import SearchBar from '../Search';

const { Content } = Layout;
const { TabPane } = Tabs;

export default function ExploreFeed(props) {
  const history = useHistory();
  const { theme } = useContext(ThemeContext);
  const { searchContent } = useContext(ExploreContext);
  const {
    users,
    setUsers,
    usersLoader,
    activeTab,
    setActiveTab,
    updateUrlTabValue,
  } = useContext(ExploreContext);
  const { profile, openProfileDrawer, loggedin } = useContext(ProfileContext);

  const callback = (key) => {
    updateUrlTabValue(key);
    setUsers([]);
    setActiveTab(key);
  };
  return (
    <div>
      <HelmetSeo
        title='Explore People | Interact'
        description='Stay upto date with friends, followers and Global family, start exploring!'
        url={`${Config.app}/explore`}
        image={`${Config.app}/images/icons/new-icon-512x512.png`}
      />
      <Content
        style={{
          padding: '80px 1.5rem 1.5rem 1.5rem',
          background: theme.content.bg,
        }}
      >
        <Row>
          <Col xs={0} sm={0} md={4} lg={6} />
          <Col xs={24} sm={24} md={16} lg={12}>
            {searchContent.show && <SearchBar />}
            <Tabs
              // style={{alignItems: 'center'}}
              tabPosition='top'
              defaultActiveKey={activeTab}
              onChange={callback}
            >
              <TabPane
                tab={
                  <span style={{ color: theme.content.text }}> Friends </span>
                }
                key='friends'
              >
                <ExploreUser loading={usersLoader} users={users} />
              </TabPane>
              <TabPane
                tab={
                  <span style={{ color: theme.content.text }}> Following </span>
                }
                key='following'
              >
                <ExploreUser loading={usersLoader} users={users} />
              </TabPane>
              <TabPane
                tab={
                  <span style={{ color: theme.content.text }}> Followers </span>
                }
                key='followers'
              >
                <ExploreUser loading={usersLoader} users={users} />
              </TabPane>
              <TabPane
                tab={
                  <span style={{ color: theme.content.text }}> Global </span>
                }
                key='global'
              >
                <ExploreUser loading={usersLoader} users={users} />
              </TabPane>
            </Tabs>
            <Row
              style={{
                // position: '-webkit-sticky',
                position: 'sticky',
                bottom: '1rem',
                marginTop: '1rem',
              }}
            >
              {loggedin ? (
                <Col xs={22} style={{ padding: '0 0.5rem 0 0' }}>
                  <Button
                    block
                    type='primary'
                    size='large'
                    shape='round'
                    icon={<ArrowLeftOutlined />}
                    onClick={() => {
                      history.push('/');
                    }}
                  >
                    Back to your Feed
                  </Button>
                </Col>
              ) : (
                <Col xs={22} style={{ padding: '0 0.5rem 0 0' }}>
                  <Button
                    block
                    type='primary'
                    size='large'
                    shape='round'
                    icon={<LoginOutlined />}
                    onClick={() => {
                      const returnTo = window.location.origin;
                      window.location.href = `https://auth.rajchandra.me/login?returnTo=${encodeURIComponent(
                        returnTo
                      )}`;
                    }}
                  >
                    Login to your Account
                  </Button>
                </Col>
              )}
              <Col
                style={{
                  cursor: 'pointer',
                  textAlign: 'center',
                }}
                xs={2}
              >
                <Avatar
                  size='large'
                  onClick={openProfileDrawer}
                  icon={
                    <img
                      src={profile.userData.user.picture.replace(
                        's96-c',
                        's512-c',
                        true
                      )}
                      width='25'
                      alt={profile.userData.user.name.fullName}
                    />
                  }
                >
                  {profile.userData.user.name.fullName}
                </Avatar>
              </Col>
            </Row>
          </Col>
          <Col xs={0} sm={0} md={4} lg={6} />
        </Row>
      </Content>
    </div>
  );
}
